import React from 'react'
import LayoutContainer from './component/LayoutContainer'

export default (Component) => (props) => {
    return <LayoutContainer><Component {...props}/></LayoutContainer>
}



// WEBPACK FOOTER //
// ./src/modules/layout/withLayout.js